import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Could not find root element to mount to');
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    {process.env.REACT_APP_LOCAL_DEMO === 'true' && (
      <div role="status" style={{ position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 2147483647, background: '#fbbf24', color: '#111827', textAlign: 'center', fontSize: 12, fontWeight: 800, padding: 5, pointerEvents: 'none' }}>
        AMBIENTE DE TESTES — dados fictícios · sem cobranças reais
      </div>
    )}
    <App />
  </React.StrictMode>
);

if ('serviceWorker' in navigator && window.location.hostname === 'localhost') {
  window.addEventListener('load', async () => {
    const registrations = await navigator.serviceWorker.getRegistrations();
    await Promise.all(registrations.map(registration => registration.unregister()));

    if ('caches' in window) {
      const cacheNames = await caches.keys();
      await Promise.all(cacheNames.map(cacheName => caches.delete(cacheName)));
    }
  });
}

if ('serviceWorker' in navigator && window.location.protocol === 'https:' && window.location.hostname !== 'localhost') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((error) => {
      console.warn('FlowTab PWA não foi ativado:', error);
    });
  });
}
